/* global axios */
import ApiClient from './ApiClient';

class FollowUpSequencesAPI extends ApiClient {
  constructor() {
    super('follow_up_sequences', { accountScoped: true });
  }

  getStats(sequenceId) {
    return axios.get(`${this.url}/${sequenceId}/stats`);
  }

  getEnrolledContacts(sequenceId) {
    return axios.get(`${this.url}/${sequenceId}/enrolled_contacts`);
  }

  enroll(sequenceId, contactIds) {
    return axios.post(`${this.url}/${sequenceId}/enroll`, {
      contact_ids: contactIds,
    });
  }

  cancelContact(sequenceId, contactId, reason = null) {
    return axios.post(`${this.url}/${sequenceId}/cancel_contact`, {
      contact_id: contactId,
      reason,
    });
  }

  // Steps
  getSteps(sequenceId) {
    return axios.get(`${this.url}/${sequenceId}/steps`);
  }

  createStep(sequenceId, stepData) {
    return axios.post(`${this.url}/${sequenceId}/steps`, { step: stepData });
  }

  updateStep(sequenceId, stepId, stepData) {
    return axios.put(`${this.url}/${sequenceId}/steps/${stepId}`, {
      step: stepData,
    });
  }

  deleteStep(sequenceId, stepId) {
    return axios.delete(`${this.url}/${sequenceId}/steps/${stepId}`);
  }
}

export default new FollowUpSequencesAPI();
